import { Link } from 'react-router-dom';
import { featuredManga } from '@/mocks/manga';
import { categories } from '@/mocks/manga';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20dark%20atmosphere%20with%20warm%20crimson%20and%20gold%20accents%2C%20ink%20wash%20textures%20blending%20with%20modern%20gradients%2C%20subtle%20Japanese%20wave%20patterns%2C%20elegant%20minimalist%20composition%2C%20deep%20charcoal%20background%20with%20ambient%20warm%20light%2C%20cinematic%20mood%2C%20no%20text%2C%20no%20people&width=1800&height=800&seq=hero-bg-manga&orientation=landscape"
        alt="漫境 - 成人漫画精选推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 text-center leading-tight max-w-3xl">
          成人漫画精选推荐
          <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 text-foreground-200">
            高质内容一站畅览
          </span>
        </h1>
        <p className="mt-6 text-sm md:text-base text-foreground-300 text-center max-w-2xl leading-relaxed">
          探索优质成人漫画资源，涵盖悬疑惊悚、都市情感、历史传奇、科幻奇幻等多种风格。
          正版授权，安全私密，为成熟读者提供深度故事与艺术画风的多元阅读体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/xuan-yi-jing-song"
            className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-foreground-300/40 text-foreground-200 text-sm font-medium rounded-md hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-8 mt-12">
          {[
            { value: '2,500+', label: '精选作品' },
            { value: '120+', label: '合作版权方' },
            { value: '38万+', label: '注册读者' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-xl md:text-2xl font-bold text-accent-500">{stat.value}</div>
              <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-foreground-300 text-2xl"></i>
      </div>
    </section>
  );
}